export default __webpack_public_path__ + "static/media/USAopt.d063e2d2.jpg";